import { useLocaleMapping } from "@/Composables/useLocaleMapping";

export const useDate = () => {
    const { mappedLocale } = useLocaleMapping();
    const formatDate = (date, options = null) => {
        return new Intl.DateTimeFormat(
            mappedLocale.value,
            options || {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
            }
        ).format(_prepareDate(date));
    };

    const formatTime = (date, options = null) => {
        return new Intl.DateTimeFormat(
            mappedLocale.value,
            options || {
                timeStyle: "medium",
            }
        ).format(_prepareDate(date));
    };

    const formatDateTime = (date, options = null) => {
        return new Intl.DateTimeFormat(
            mappedLocale.value,
            options || {
                dateStyle: "medium",
                timeStyle: "medium",
            }
        ).format(_prepareDate(date));
    };

    const prependZero = (value) => {
        return value < 10 ? `0${value}` : value;
    };

    const _prepareDate = (date) => {
        if (!date) return;
        if (typeof date === "string" || typeof date === "number") {
            date = new Date(date);
        }
        if (!(date instanceof Date)) {
            throw new Error("Invalid date");
        }
        return date;
    };

    return {
        formatDate,
        formatTime,
        formatDateTime,
        prependZero,
    };
};
